import React from 'react';
import PropTypes from 'prop-types';
import ConfigureCostObject from './comp/ConfigureCostObject';
import AddIcon from '@material-ui/icons/AddCircle';
import { PERCENTAGE_OF_GROSS_RADIO_BUTTON, SELECT_ALLOCATION_UNIT_RADIO_BUTTON } from './RadioButtonsConstants';

const emptyCostObject = {
  id: 0,
  name: '',
  amount: '',
  percentageOfGross:''
};

class ManageConfigureCostObject extends React.Component {
  constructor(props) {
    super(props);
    const costObjects = props.costObjects;
    this.state = {
      costObjects,
      sumPercentageOfGross: 0,
      lastInputFieldSelected: 0
    };
  }

  componentDidMount = () => {
    this.props.costObjsActions.clearCostObjects();
    this.props.costObjsActions.fetchAllCostObjs();
    if(this.props.allocationUnitId !== 0){
      this.props.costObjsActions.fetchCostObjsByAllocationUnitId(this.props.allocationUnitId);
    }
  };

  componentWillReceiveProps(nextProps) {
    if(this.props.allocationUnitId !== nextProps.allocationUnitId && nextProps.allocationUnitId !== 0) {
      this.props.costObjsActions.fetchCostObjsByAllocationUnitId(nextProps.allocationUnitId);
    }
    if (this.props.radioButtonValue !== nextProps.radioButtonValue || this.props.allocationUnitId !== nextProps.allocationUnitId) {
      this.enableSelectedCostObjects();
      this.setState({
        costObjects: new Array(emptyCostObject),
        sumPercentageOfGross: 0,
        lastInputFieldSelected: 0
      }, () => {
        this.props.onCostObjectChange(this.state.costObjects);
      });
    }
    if(this.props.allCostObjs.length === 0 && nextProps.allCostObjs.length !== 0){
      this.disableSelectedCostObjects();
    }
    if(this.props.costObjs.length === 0 && nextProps.costObjs.length !== 0){
      this.disableSelectedCostObjects();
    }
  }

  disableSelectedCostObjects = () => {
    this.props.costObjects.forEach(costObject => {
      this.handleSelectCostObject(0, costObject.id);
    });
  };

  enableSelectedCostObjects = () =>{
    this.props.costObjects.forEach(costObject => {
      this.handleSelectCostObject(costObject.id, 0);
    });
  };

  handleCostObjectChange = (newCostObject, index) => {
    const newCostObjectList = this.state.costObjects.map((costObject, newIndex) => {
      if (index !== newIndex) return { ...costObject };
      return { ...newCostObject };
    });

    this.setState({ costObjects: [...newCostObjectList], sumPercentageOfGross: this.handlePercentageOfGross(newCostObjectList) }, () => {
      this.props.onCostObjectChange(this.state.costObjects);
    });
  };

  handleAddCostObject = () => {
    if(this.isAddCostObjectButtonEnable()){
      return null;
    }else {
      let newCostObjectLists = [...this.state.costObjects];
      this.setState(({ costObjects: [] }), () => {
        this.setState({ costObjects: [ ...newCostObjectLists, emptyCostObject]  }, () => {
          this.props.onCostObjectChange(this.state.costObjects);
        });
      });
    }
  };

  handleRemoveCostObject = (index) => {
    let newCostObjectList = [...this.state.costObjects];
    const removedCostObject = newCostObjectList[index];

    if(removedCostObject.id === this.state.lastInputFieldSelected){
      this.setState({ lastInputFieldSelected: newCostObjectList[index-1] === undefined ? newCostObjectList[index+1].id : newCostObjectList[index-1].id});
    }
    newCostObjectList.splice(index, 1);
    this.setState(({ costObjects: [] }), () => {
      this.setState(({ costObjects: [...newCostObjectList], sumPercentageOfGross: this.handlePercentageOfGross(newCostObjectList) }), () => {
        this.props.onCostObjectChange(this.state.costObjects);
      });
    });
    this.handleSelectCostObject(removedCostObject.id, 0);
  };

  handleSelectCostObject = (oldCostObject, newCostObject) => {
    this.props.costObjsActions.selectedCostObject(oldCostObject, newCostObject);
  };

  handlePercentageOfGross = costObjects => {
    let sumPercentageOfGross = 0;
    costObjects.forEach(costObject => { sumPercentageOfGross += parseInt(costObject.percentageOfGross === '' ? 0 : costObject.percentageOfGross);});
    return sumPercentageOfGross;
  };

  handleLastInputFieldSelected = lastInputFieldSelected =>  this.setState({ lastInputFieldSelected: lastInputFieldSelected });

  isAddCostObjectButtonEnable = () =>{
    const { radioButtonValue, costObjs, allCostObjs, costObjects } =this.props;
    const { sumPercentageOfGross } = this.state;
    return (radioButtonValue === PERCENTAGE_OF_GROSS_RADIO_BUTTON) && (sumPercentageOfGross >= 100 || allCostObjs.length <= costObjects.length) ||
      (radioButtonValue === SELECT_ALLOCATION_UNIT_RADIO_BUTTON) && (costObjs.length <= costObjects.length);
  };

  render() {
    const { radioButtonValue, costObjs, fetchingCostObjs, allocationUnitId, allCostObjs, costObjects } =this.props;
    const { sumPercentageOfGross, lastInputFieldSelected } = this.state;

    return(
      <div>
        {
          costObjects.map((costObject, index) => (
            <ConfigureCostObject
              key={ index }
              showRemoveIcon={ costObjects.length > 1 }
              fetchingCostObjects={ fetchingCostObjs }
              costObjects={ radioButtonValue === PERCENTAGE_OF_GROSS_RADIO_BUTTON ? allCostObjs : costObjs }
              radioButtonValue={ radioButtonValue }
              costObject={ costObject }
              allocationUnitId={ allocationUnitId }
              onCostObjsChange={ newCostObject => this.handleCostObjectChange(newCostObject, index) }
              onRemoveCostObject={ () => this.handleRemoveCostObject(index) }
              onSelectCostObject={ this.handleSelectCostObject }
              isPercentageOfGrossExceeded={ sumPercentageOfGross > 100 }
              onLastInputFieldSelected={ this.handleLastInputFieldSelected }
              lastInputFieldSelected={ lastInputFieldSelected }
            />
          ))
        }
        <div className="add-cost-object-container">
          <div style={ {color:  this.isAddCostObjectButtonEnable() ? '#999999' : '', cursor: this.isAddCostObjectButtonEnable() ? 'not-allowed' : 'pointer', display: 'flex' } } onClick={ this.handleAddCostObject }>
            <AddIcon style={ {fontSize: 18, marginRight: 5, cursor: this.isAddCostObjectButtonEnable() ? 'not-allowed' : 'pointer'} }  />
            <div style={ {fontSize: 14, cursor: this.isAddCostObjectButtonEnable() ? 'not-allowed' : 'pointer' } } >ADD COST OBJECT</div>
          </div>
        </div>
      </div>
    );
  }
}

ManageConfigureCostObject.propTypes = {
  costObjects: PropTypes.array.isRequired,
  radioButtonValue: PropTypes.string,
  fetchingCostObjs: PropTypes.bool,
  costObjs: PropTypes.array,
  allCostObjs: PropTypes.array,
  costObjsActions: PropTypes.shape({
    fetchAllCostObjs: PropTypes.func,
    fetchCostObjsByAllocationUnitId: PropTypes.func,
    selectedCostObject: PropTypes.func,
    clearCostObjects: PropTypes.func
  }),
  onCostObjectChange: PropTypes.func.isRequired,
  allocationUnitId: PropTypes.number.isRequired
};

export default ManageConfigureCostObject;



// WEBPACK FOOTER //
// ./src/components/manageRules/comp/ruleEditor/comp/ruleBuilder/allocationContainer/ManageConfigureCostObject.js